import type { SVGProps } from 'react';

const SvgSavedSearch = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M18 15c-.55 0-1 .45-1 1v2.61l-4.68-1.56a.97.97 0 0 0-.63 0l-4.68 1.56V6c0-.55.45-1 1-1s1-.45 1-1-.45-1-1-1c-1.65 0-3 1.35-3 3v14c0 .32.15.62.42.81a1 1 0 0 0 .9.14l5.68-1.89 5.68 1.89c.1.03.21.05.32.05.21 0 .41-.06.58-.19.26-.19.42-.49.42-.81v-4c0-.55-.45-1-1-1z"
    />
    <path
      fill="currentcolor"
      d="m20.71 12.29-1.54-1.54c.52-.79.83-1.74.83-2.75 0-2.76-2.24-5-5-5s-5 2.24-5 5 2.24 5 5 5c1.02 0 1.96-.31 2.75-.83l1.54 1.54c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41zM12 8c0-1.65 1.35-3 3-3s3 1.35 3 3-1.35 3-3 3-3-1.35-3-3"
    />
  </svg>
);
export default SvgSavedSearch;
